import OptionTooltip from "components/Blocks/OptionTooltip/OptionTooltip";

export default OptionTooltip;
